import { FuelTransaction } from "@fairfleet/geotab";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_FUEL_TRANSACTION } from "@/constants/resultsLimits";
import { usePerDeviceQueries } from "@/hooks/usePerDeviceQueries";

export const FUEL_TRANSACTIONS_QUERY_KEY = "fuelTransactions";

/** Geotab `FuelTransaction` records (refuelling) per device for a period. */
export function useFuelTransactionsForDevices(
  deviceIds: string[],
  fromDate: Date,
  toDate: Date,
  enabled = true,
) {
  const { geotabClient } = useGeotabClient();

  return usePerDeviceQueries<FuelTransaction>({
    queryKey: FUEL_TRANSACTIONS_QUERY_KEY,
    deviceIds,
    fromDate,
    toDate,
    enabled,
    fetchRecords: (deviceId, signal) =>
      geotabClient.get(
        "FuelTransaction",
        { deviceSearch: { id: deviceId }, fromDate, toDate },
        RESULTS_LIMIT_FUEL_TRANSACTION,
        signal,
      ),
  });
}
